var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F9E719"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2667 8.09167C20.1 7.6 19.6333 7.25 19.0833 7.25H9.91667C9.36667 7.25 8.90833 7.6 8.73333 8.09167L7 13.0833V19.75C7 20.2083 7.375 20.5833 7.83333 20.5833H8.66667C9.125 20.5833 9.5 20.2083 9.5 19.75V18.9167H19.5V19.75C19.5 20.2083 19.875 20.5833 20.3333 20.5833H21.1667C21.625 20.5833 22 20.2083 22 19.75V13.0833L20.2667 8.09167ZM9.91667 16.4167C9.225 16.4167 8.66667 15.8583 8.66667 15.1667C8.66667 14.475 9.225 13.9167 9.91667 13.9167C10.6083 13.9167 11.1667 14.475 11.1667 15.1667C11.1667 15.8583 10.6083 16.4167 9.91667 16.4167ZM19.0833 16.4167C18.3917 16.4167 17.8333 15.8583 17.8333 15.1667C17.8333 14.475 18.3917 13.9167 19.0833 13.9167C19.775 13.9167 20.3333 14.475 20.3333 15.1667C20.3333 15.8583 19.775 16.4167 19.0833 16.4167ZM8.66667 12.25L9.91667 8.5H19.0833L20.3333 12.25H8.66667Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveVehicle);
export default __webpack_public_path__ + "static/media/inactive_vehicle.5fdcd19b50cd047a7d9efeb8b8d3743e.svg";
export { ForwardRef as ReactComponent };